import { HttpHeaders, HttpParams, HttpClient } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import { SharedService } from "./sharedService";
import { lang } from "moment";

declare var toastr: any;
import * as XLSX from "xlsx";
import { CouponResponse } from "../../assets/config/models";
import { CountryCodeDetails } from "../types/country-codes.model";
@Injectable({
  providedIn: "root",
})
export class CoreService {
  private apiDomain: any;
  private Domain: any;
  private jwt: any;
  sizeOptions = [5, 10, 15, 20, 50];
  passColor = this.ss.passColor;
  colorScheme = this.ss.colorScheme;
  passColorScheme = this.ss.passColorScheme;
  bsConfig = Object.assign({}, { containerClass: "theme-blue" });
  public sidbarRef$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  constructor(
    private http: HttpClient,
    private ss: SharedService,
  ) {
    this.apiDomain = ss.apiDomain;
    this.Domain = ss.Domain;
    this.jwt = localStorage.getItem("jwt");
  }

  createAuthorizationHeader() {
    return new HttpHeaders({
      Authorization: "JWT " + localStorage.getItem("jwt"),
    });
  }

  GetServerTime() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/server-time/", { headers: headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingPlaces(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "parking-places/" + head, {
      headers: headers,
    });
  }

  GetParkingPlaceRegConfig() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/reg-config/", { headers: headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingPlaceSuscription(parking_place_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(
        this.apiDomain +
          "parking-manager/tenantdropdown?parking_place_id=" +
          parking_place_id,
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetValetStaffByTicketIdSuscription(ticket_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(
        this.apiDomain + "pass-valet/get-staff-list/?ticket_id=" + ticket_id,
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  modifyTicketStatusByStaff(ticket_id, valet_staff_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(
        this.apiDomain +
          "pass-valet/modify-valet-ticket/?ticket_id=" +
          ticket_id +
          "&valet_staff_id=" +
          valet_staff_id,
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  SaveParkingPlace(data): Promise<any> {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .post(this.apiDomain + "parking-places/", data, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateParkingPlace(data, id): Promise<any> {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(this.apiDomain + "parking-places/" + id + "/", data, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UploadParkingPlaceVideo(data): Promise<any> {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(
        this.apiDomain + "parking-places/parking-video-upload/",
        data,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteParkingPlace(id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .delete(this.apiDomain + "parking-places/" + id + "/", options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  VehicleConfiguration() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "customers/vehicles/vehicle-configurations/", {
        headers: headers,
      })
      .toPromise();
  }

  GetParkingPlace(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/?id=" + id, { headers: headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteChargeStack(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + "parking-places/charge-stacks/" + id + "/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetCouponReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/coupon-report/" + head, {
      headers: headers,
    });
  }

  GetParkingLogs(params, form, sorts, date?, isPrebooking = false) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    if (isPrebooking && form.ticket_type.value != null)
      head += `&prebooking_ticket_type=${form.ticket_type.value}`;

    for (let key of Object.keys(form)) {
      if (isPrebooking && key == "ticket_type") head = head;
      else
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/parking-logs/" + head, {
      headers: headers,
    });
  }
  GetParkingLogsSubscriber(
    params,
    form,
    sorts,
    date?,
    isAdmin = false,
    isPrebooking = false,
  ) {
    let headers = this.createAuthorizationHeader();
    let subscription_type = 1;
    if (isAdmin) {
      subscription_type = 2;
    }
    params = `offset=${params.offset}&limit=${params.limit}&subscription_type=${subscription_type}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    if (isPrebooking)
      head += `&prebooking_ticket_type=${form.ticket_type.value}`;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/parking-logs/" + head, {
      headers: headers,
    });
  }

  GetPassWithoutCharge(
    params,
    form,
    sorts,
    date?,
    isAdmin = false,
    isPrebooking = false,
  ) {
    let headers = this.createAuthorizationHeader();
    let subscription_type = 1;
    if (isAdmin) {
      subscription_type = 2;
    }
    params = `offset=${params.offset}&limit=${params.limit}&subscription_type=${subscription_type}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    if (isPrebooking)
      head += `&prebooking_ticket_type=${form.ticket_type.value}`;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain +
        "backend/parking-manager/pass_close_ticket_feature_report/" +
        head,
      {
        headers: headers,
      },
    );
  }

  ExportPassWithoutCharge(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain +
          "backend/parking-manager/pass_close_ticket_feature_report/" +
          head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `PassWithoutCharge.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetCatamaranParkingLogsSubscriber(
    params,
    form,
    sorts,
    date?,
    isAdmin = false,
  ) {
    let headers = this.createAuthorizationHeader();
    let subscription_type = 1;
    if (isAdmin) {
      subscription_type = 2;
    }
    params = `offset=${params.offset}&limit=${params.limit}&subscription_type=${subscription_type}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      if (key != "title")
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/catamaran-subscriber-parking-logs/" + head,
      {
        headers: headers,
      },
    );
  }
  GetUnregisteredTickets(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(this.apiDomain + "pass-valet/car-brand-list/", {
      headers: headers,
    });
  }
  GetSystemMessages(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(
      this.apiDomain + "pass-valet/valet-message-templates/",
      {
        headers: headers,
      },
    );
  }
  GetExitWithoutEntryLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/exit-without-entry-logs/" + head,
      {
        headers: headers,
      },
    );
  }

  GetOverstayedParkingLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/overstay-parking-logs/" + head,
      {
        headers: headers,
      },
    );
  }

  GetBlacklistedParkingLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/blacklist-parking-logs/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportBlacklistedParkingLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/blacklist-parking-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `ManualTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  CloseBlacklistedParkingLogs(form) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "backend/close-manual-tickets/",
      form,
      options,
    );
  }
  CloseParkingTickets(form) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "backend/close-parking-tickets/",
      form,
      options,
    );
  }

  CloseNonPassParking(form) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "backend/close-parking-traffic/",
      form,
      options,
    );
  }
  CreateCarBrand(form) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "pass-valet/car-brand-list/",
      form,
      options,
    );
  }
  CreateSystemMessage(form) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "pass-valet/valet-message-templates/",
      form,
      options,
    );
  }
  UpdateCarBrand(form, id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.put(
      this.apiDomain + `pass-valet/car-brand-list/${id}/`,
      form,
      options,
    );
  }
  UpdateSystemMessage(form, id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.put(
      this.apiDomain + `pass-valet/valet-message-templates/${id}/`,
      form,
      options,
    );
  }
  DeleteCarBrand(id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.delete(
      this.apiDomain + `pass-valet/car-brand-list/${id}/`,
      options,
    );
  }
  DeleteSystemMessage(id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.delete(
      this.apiDomain + `pass-valet/valet-message-templates/${id}/`,
      options,
    );
  }

  GetKnetLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/knet-transactions/" + head, {
      headers: headers,
    });
  }

  GetBenefitLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/benefit-transactions/" + head,
      {
        headers: headers,
      },
    );
  }
  GetMadaLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/mada-transactions/" + head, {
      headers: headers,
    });
  }

  ExportKnetLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/knet-transactions/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `KNETReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }
  ExportMadaLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/mada-transactions/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `MADAReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportBenefitLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/benefit-transactions/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `BenefitReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportCouponsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/coupon-report/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CouponsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportCoupon(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/coupons/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CouponsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportParkingLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/parking-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `TicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportParkingLogsSubscriberReport(
    params,
    form,
    sorts,
    date?,
    isAdmin = false,
  ) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    let subscription_type = 1;
    if (isAdmin) {
      subscription_type = 2;
    }
    params = `offset=${params.offset}&limit=${params.limit}&subscription_type=${subscription_type}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/parking-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `TicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportCatamaranParkingLogsSubscriberReport(
    params,
    form,
    sorts,
    date?,
    isAdmin = false,
  ) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    let subscription_type = 1;
    if (isAdmin) {
      subscription_type = 2;
    }
    params = `offset=${params.offset}&limit=${params.limit}&subscription_type=${subscription_type}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      if (key != "title")
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "backend/catamaran-subscriber-parking-logs/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CatamaranTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportExitWithoutEntryLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/exit-without-entry-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `ExitWithoutEntryLogs.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportOverstayedParkingLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/overstay-parking-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `OverstayTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetUsers(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractUserDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/users/" + head, {
      headers: headers,
    });
  }

  ExportCouponReport(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/users/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `USERReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportUsersReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractUserDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/users/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `USERReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetUserParkingLogs(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&user_id=${id}`;
    return this.http.get(this.apiDomain + "backend/parking-logs/" + head, {
      headers: headers,
    });
  }

  GetUserVigilanteLogs(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + `backend/user-vigilant-log/${id}/` + head,
      {
        headers: headers,
      },
    );
  }
  GetPaymentSourceLogs(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}&user_id=${id}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + `backend/payment-source-logs/` + head,
      {
        headers: headers,
      },
    );
  }

  GetUserTransactionLogs(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&user_id=${id}`;
    return this.http.get(this.apiDomain + "backend/transaction-logs/" + head, {
      headers: headers,
    });
  }

  GetUserVehicles(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&user_id=${id}`;
    return this.http.get(this.apiDomain + "backend/vehicles/" + head, {
      headers: headers,
    });
  }

  EditUserVehicle(form, id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .put(this.apiDomain + `customers/vehicles/${id}/`, form, {
        headers: headers,
      })
      .toPromise();
  }

  DeleteUserVehicle(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/vehicles/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetTransactionLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(
        `&${key}=${form[key].value === false ? "" : form[key].value}`,
      );
    }
    return this.http.get(this.apiDomain + "backend/transaction-logs/" + head, {
      headers: headers,
    });
  }

  ExportTransactionLogsReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/transaction-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `TransactionsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ChangeBanUser(form: object) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "customers/user-ban/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetStaff() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/parking-staff-list/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  AssignStaff(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "backend/update-parking-staff/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetAllValetSites(): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `JWT ${localStorage.getItem("jwt")}`,
      "Content-Type": "application/json",
    });

    const dropdownUrl =
      this.apiDomain + "pass-valet/valet-report-heading-dropdowns/";

    return this.http.get<any>(dropdownUrl, { headers });
  }

  GetParkingPlacesList() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/parking-place-list/?settlement=1", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetAllParkingPlacesList() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/parking-place-list/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  PrebookingDropdownStatus() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/dropdown-booking-status/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetParkingPlacesListWithoutSettlement() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "parking-places/parking-place-list/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetChannelPartnersList() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/account/?settlement=1", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetCashierLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/parking-logs/" + head, {
      headers: headers,
    });
  }
  GetRevenuesDetails(id, date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `${this.extractDateChart(date)}`;
    return this.http
      .get(
        this.apiDomain +
          `parking-places/revenues/?parking_place=${id}&${params}`,
        {
          headers: headers,
        },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetVisitorsDetails(id, date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `${this.extractDateChart(date)}`;
    return this.http
      .get(
        this.apiDomain +
          `parking-places/visitors-count/?parking_place=${id}&${params}`,
        {
          headers: headers,
        },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetDashboardData(date) {
    let headers = this.createAuthorizationHeader();
    let params = date ? `?${this.extractDate(date)}` : "";
    return this.http
      .get(this.apiDomain + "backend/dashboard-api/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetUsersMap(date) {
    let headers = this.createAuthorizationHeader();
    let params = date ? `?${this.extractDateChart(date)}` : "";
    return this.http
      .get(this.apiDomain + "parking-places/users-map/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetHeatMap(date?, parking_id?) {
    let headers = this.createAuthorizationHeader();
    let params = date
      ? new HttpParams({ fromString: this.extractDateChart(date) })
      : new HttpParams();
    if (parking_id) {
      params = params.append("parking_place_id", parking_id);
    }
    return this.http
      .get(this.apiDomain + "parking-places/parking-map/", {
        headers: headers,
        params: params,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetVisitors(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/visitors-count/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetRevenues(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/revenues/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetPeakHours(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/parking-peak-hour/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetGendersChart(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/parking-gender/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetAgeChart(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/parking-age/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetCapacity(id) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    return this.http
      .get(this.apiDomain + "parking-places/capacity/?parking_place_id=" + id, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ChangeParkingPlaceBan(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "parking-places/parking-enable/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ChangeParkingPlaceHidden(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "parking-places/parking-hidden/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ChangeParkingPlaceMultistorey(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "parking-places/parking-multistorey/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ChangeBan(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "parking-places/vehicle-ban/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingReports(id, date) {
    let headers = this.createAuthorizationHeader();
    console.log(id);
    console.log(date);
    let head = "?";
    head = head.concat(`parking_place_id=${id}`);
    head = head.concat(`&${this.extractDate(date)}`);
    return this.http
      .get(
        this.apiDomain + "parking-places/parking-place-revenue-report/" + head,
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ExportTicketLogsReport(form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    // params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&user_id=${id}`;
    head = head.concat(`&report=1`);
    return this.http
      .get(this.apiDomain + "backend/parking-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `TicketLogsReport${id}.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportParkingReport(id, date) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    let head = "?";
    head = head.concat(`&parking_place_id=${id}`);
    head = head.concat(`&${this.extractDate(date)}`);
    head = head.concat(`&report=true`);
    this.http
      .get(
        this.apiDomain + "parking-places/parking-place-revenue-report/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) =>
          this.downloadExcel(
            data,
            `${this.extractDate(date)}RevenueReport.xlsx`,
          ),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ChannelAddUser(form) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(this.apiDomain + "backend/channel/users/", form, {
      headers: headers,
    });
  }

  ChannelAddVehicle(form) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(this.apiDomain + "backend/channel/vehicles/", form, {
      headers: headers,
    });
  }

  GetCoupons(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "pass-valet/coupons/" + head, {
      headers: headers,
    });
  }

  GetGuestSubscribers(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "guest_subscribers/guest-transactions/" + head,
      {
        headers: headers,
      },
    );
  }

  AddGuestSubscriber(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "guest_subscribers/guest-transactions/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteCoupon(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `pass-valet/coupons/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  AddCoupon(form) {
    let headers = this.createAuthorizationHeader();
    form.expiry_date = this.formatDateTime(form.expiry_date);
    form.start_date = this.formatDateTime(form.start_date);
    return this.http
      .post(this.apiDomain + "pass-valet/coupons/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  EditCoupon(form, id) {
    let headers = this.createAuthorizationHeader();
    form.expiry_date = this.formatDateTime(form.expiry_date);
    form.start_date = this.formatDateTime(form.start_date);
    return this.http
      .put(this.apiDomain + "pass-valet/coupons/" + id + "/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ApplyCoupon(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "backend/apply-coupon/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  formatDateTime(date, addSeconds = false) {
    if (date != null && date != "") {
      let temp: any = new Date(date);
      return `${temp.getDate()}-${
        temp.getMonth() + 1
      }-${temp.getFullYear()} ${temp.getHours()}:${temp.getMinutes()}`;
      return temp;
    } else {
      return null;
    }
  }

  AddVehicleConfig(form) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(this.apiDomain + "backend/vehicle-configuration/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  EditVehicleConfig(form, id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .put(this.apiDomain + "backend/vehicle-configuration/" + id + "/", form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteVehicleConfig(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/vehicle-configuration/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetVehicleConfig() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/vehicle-configuration/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetNotificationTemplates() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/message-templates/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  SendNotifications(form, params?) {
    let headers = this.createAuthorizationHeader();
    let head = "";
    if (params) {
      // add the first '?'
      head = head.concat("?");
      for (let key of Object.keys(params)) {
        // Add the '&' at the end
        head = head.concat(`${key}=${params[key] ? params[key] : ""}&`);
      }
      // remove the final '&'
      head = head.slice(0, -1);
    }
    return this.http.post(
      this.apiDomain + "backend/send-message/" + head,
      {
        ...form,
      },
      {
        headers: headers,
      },
    );
  }

  GetSubscriptionsCompany(date?, title?) {
    let headers = this.createAuthorizationHeader();

    // sorts = sorts?  `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "";
    if (title) {
      head = "?title=" + title;
      if (date) {
        if (date.length > 0) {
          head = head.concat(`&${this.extractDate(date)}`);
        }
      }
    } else {
      if (date) {
        if (date.length > 0) head = head.concat(`?${this.extractDate(date)}`);
      }
    }

    return this.http.get(`${this.apiDomain}backend/subscription/` + head, {
      headers: headers,
    });
  }

  GetSubscriptions(sorts?) {
    let headers = this.createAuthorizationHeader();
    // sorts = sorts?  `&sortby=${sorts.prop}_${sorts.dir}` : "";
    // let head = "?" + sorts;
    return this.http.get(`${this.apiDomain}backend/user-subscription/`, {
      headers: headers,
    });
  }

  GetUserVehicleSubscriptions(params: any, id: any) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "&" + params;
    return this.http.get(
      `${this.apiDomain}backend/user-vehicle-subscription/?user_id=${id}` +
        head,
      {
        headers: headers,
      },
    );
  }
  DeleteSubscription(id: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/subscription/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetAccountSubscriptions(sorts?) {
    let headers = this.createAuthorizationHeader();
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + sorts;
    return this.http.get(
      `${this.apiDomain}backend/account/account-subscriptions/` + head,
      {
        headers: headers,
      },
    );
  }

  GetAllAccountSubscriptions() {
    let headers = this.createAuthorizationHeader();

    return this.http
      .get(`${this.apiDomain}backend/account/account-subscriptions/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  CreateUserVehicle(list: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(
        `${this.apiDomain}backend/private-parking/create-user-vehicle/`,
        { ...list },
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  AddSubscription(form: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .post(
        `${this.apiDomain}backend/subscription/`,
        { ...form },
        { headers: headers },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateSubscription(id: any, form: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .put(
        `${this.apiDomain}backend/subscription/${id}/`,
        { ...form },
        {
          headers: headers,
        },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateAccountSubscription(id: any, form: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .put(
        `${this.apiDomain}backend/account/user-subscription/${id}/`,
        { ...form },
        {
          headers: headers,
        },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  DeleteAccountSubscription(id: any) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(`${this.apiDomain}backend/account/user-subscription/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetSubscribers(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    if (date.length > 0) head = head.concat(`&${this.extractDate(date)}`);

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(`${this.apiDomain}backend/user-subscription/` + head, {
      headers: headers,
    });
  }

  GetSubscribersCorporate(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      `${this.apiDomain}backend/corporate/user-subscription/` + head,
      {
        headers: headers,
      },
    );
  }

  ExportSubscribers(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    if (date.length > 0) head = head.concat(`&${this.extractDate(date)}`);
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);

    return this.http
      .get(`${this.apiDomain}backend/user-subscription/` + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) =>
          this.downloadExcel(
            data,
            `${
              date.length > 0 ? this.extractDate(date) : ""
            }SubscribersReport.xlsx`,
          ),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  AddAccountSubscriber(form) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(
      `${this.apiDomain}backend/account/user-subscription/`,
      { ...form },
      { headers: headers },
    );
  }

  AddSubscriber(form) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(
      `${this.apiDomain}backend/user-subscription/`,
      { ...form },
      { headers: headers },
    );
  }

  UpdateSubscriber(id, form) {
    let headers = this.createAuthorizationHeader();
    return this.http.put(
      `${this.apiDomain}backend/user-subscription/${id}/`,
      { ...form },
      { headers: headers },
    );
  }

  updateSubscriber(form: any = {}, id: any) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(
      `${this.apiDomain}backend/user-subscription/${id}/update/`,
      { ...form },
      { headers: headers },
    );
  }

  updateSubscriptionLimit(id, form) {
    let headers = this.createAuthorizationHeader();
    return this.http.put(
      `${this.apiDomain}backend/subscription/${id}/`,
      { ...form },
      { headers: headers },
    );
  }

  inviteSubscriber(form) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(
      `${this.apiDomain}backend/subscription-invite/`,
      { ...form },
      { headers: headers },
    );
  }

  searchEntries(term, category) {
    let headers = this.createAuthorizationHeader();
    return this.http.get(
      `${this.apiDomain}parking-places/vehicle-serach/?search_term=${term}&search_for=${category}`,
      { headers: headers },
    );
  }

  GetSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      if (key == "updated_on") {
        let date = form[key].value
          ? this.extractSingleDate(form[key].value)
          : "";
        head = head.concat(`&${key}=${date}`);
      } else {
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
      }
    }
    return this.http.get(this.apiDomain + "backend/settlement/" + head, {
      headers: headers,
    });
  }

  GetChannelTicketsSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/channel-partner-settlement/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportChannelTicketsSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "backend/channel-partner-settlement/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `TicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetChannelCollectionsSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    console.log(head);
    return this.http.get(
      this.apiDomain + "backend/collection-settlements/" + head,
      {
        headers: headers,
      },
    );
  }

  deleteCollectionSettlement(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/collection-settlements/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  updateCollectionSettlement(form, id) {
    let headers = this.createAuthorizationHeader();
    let head = id + "/";
    return this.http
      .patch(this.apiDomain + "backend/collection-settlements/" + head, form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ExportChannelCollectionsSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/collection-settlements/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CollectionsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportSettlements(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}&rows=${params.rows}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      if (key == "updated_on") {
        let date = form[key].value
          ? this.extractSingleDate(form[key].value)
          : "";
        head = head.concat(`&${key}=${date}`);
      } else {
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
      }
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/settlement/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `SettlementReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  DownloadSettlements(params) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    params = `rows=${params.rows}&class_name=settlement`;
    let head = "?" + params;

    return this.http
      .get(
        this.apiDomain + "backend/portal-download-offline-report" + head,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteSettlement(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/settlement/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteCommissionSettlement(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/channel-partner-settlement/${id}/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingSettlementFromId(params, parking_id, settlement_id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(
      `&parking_place_id=${parking_id}&settlement_id=${settlement_id}`,
    );
    return this.http.get(this.apiDomain + "backend/ticket-settlement/" + head, {
      headers: headers,
    });
  }

  GetParkingSettlement(params, id, date) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(
      `&${
        date == "" || date == null
          ? "from_date=&to_date="
          : this.extractDate(date)
      }`,
    );
    head = head.concat(`&parking_place_id=${id}`);
    return this.http.get(this.apiDomain + "backend/ticket-settlement/" + head, {
      headers: headers,
    });
  }

  GetChannelSettlementFromId(params, id, settlement_id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(
      `&channel_partner_id=${id}&channel_partner_settlement_id=${settlement_id}`,
    );
    return this.http.get(this.apiDomain + "backend/ticket-settlement/" + head, {
      headers: headers,
    });
  }

  GetChannelSettlement(params, id, date) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(
      `&${
        date == "" || date == null
          ? "from_date=&to_date="
          : this.extractDate(date)
      }`,
    );
    head = head.concat(`&channel_partner_id=${id}`);
    return this.http.get(this.apiDomain + "backend/ticket-settlement/" + head, {
      headers: headers,
    });
  }

  GetCollectionSettlementFromId(params, id, settlement_id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(`&account=${id}&settlement_status=1&is_settlement=true`);
    return this.http.get(this.apiDomain + "backend/transaction-logs/" + head, {
      headers: headers,
    });
  }

  GetCollectionSettlement(params, id?, date?, collectionID?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = head.concat(
      `&${
        date == "" || date == null
          ? "from_date=&to_date="
          : this.extractDate(date)
      }`,
    );
    head = head.concat(
      `&account=${id}&settlement_status=1&is_settlement=true&collection_settlement_id=${collectionID}`,
    );
    return this.http.get(this.apiDomain + "backend/transaction-logs/" + head, {
      headers: headers,
    });
  }

  GetSettlementDetails(settlement_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/settlement/?id=" + settlement_id, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetSettlementDetailsTemp(settlement_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/settlement/?id=" + settlement_id, {
        headers: headers,
      })
      .toPromise();
  }

  GetChannelPartnerSettlementDetails(settlement_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(
        this.apiDomain +
          "backend/channel-partner-settlement/?id=" +
          settlement_id,
        {
          headers: headers,
        },
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  InitiateSettlement(form) {
    let headers = this.createAuthorizationHeader();
    form.expiry_date = this.formatDateTime(form.expiry_date);
    form.start_date = this.formatDateTime(form.start_date);
    let body = {
      parking_place_id: form.id,
      from_date: this.formatDate(form.date[0]),
      to_date: this.formatDate(form.date[1]),
    };
    return this.http
      .post(this.apiDomain + "backend/settlement/", body, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateSettlement(form, id) {
    let headers = this.createAuthorizationHeader();
    let head = id + "/";
    return this.http
      .put(this.apiDomain + "backend/settlement/" + head, form, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  InitiateChannelPartnerSettlement(form) {
    let headers = this.createAuthorizationHeader();
    form.expiry_date = this.formatDateTime(form.expiry_date);
    form.start_date = this.formatDateTime(form.start_date);
    let body = {
      channel_partner_id: form.channel_partner_id,
      from_date: this.formatDate(form.date[0]),
      to_date: this.formatDate(form.date[1]),
    };
    return this.http
      .post(this.apiDomain + "backend/channel-partner-settlement/", body, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  InitiateChannelPartnerCollectionSettlement(form) {
    let headers = this.createAuthorizationHeader();
    form.expiry_date = this.formatDateTime(form.expiry_date);
    form.start_date = this.formatDateTime(form.start_date);
    let body = {
      channel_partner_id: form.channel_partner_id,
      from_date: this.formatDate(form.date[0]),
      to_date: this.formatDate(form.date[1]),
    };
    return this.http
      .post(this.apiDomain + "backend/collection-settlements/", body, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetAllTimeStats(date) {
    let headers = this.createAuthorizationHeader();
    let params = date ? `?${this.extractDateChart(date)}` : "";
    return this.http
      .get(this.apiDomain + "parking-places/alltime-stat/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  formatDate(date) {
    if (date != null && date != "") {
      let temp = new Date(date);
      console.log("temp is:", temp);
      return `${temp.getDate()}-${temp.getMonth() + 1}-${temp.getFullYear()}`;
    } else {
      return null;
    }
  }

  CreateStaff(form) {
    let headers = this.createAuthorizationHeader();
    console.log("Headers are ", headers);
    return this.http
      .post(this.apiDomain + "backend/create-user/", form, { headers })
      .toPromise();
  }

  GetUser(user_id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/users/?user_id=" + user_id, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteUser(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/users/${id}`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteSubscriber(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + `backend/user-subscription/${id}`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateUser(data, user_id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(this.apiDomain + "backend/users/" + user_id + "/", data, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingPlaceStaffs(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&place_id=${id}`;
    return this.http.get(
      this.apiDomain + "backend/parking-place/staffs/" + head,
      {
        headers: headers,
      },
    );
  }

  GetParkingPlaceHistory(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&parking_place_id=${id}`;
    return this.http.get(this.apiDomain + "backend/parking-logs/" + head, {
      headers: headers,
    });
  }

  GetPOSMachines(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&parking_place=${id}`;
    return this.http.get(this.apiDomain + "parking-places/machines/" + head, {
      headers: headers,
    });
  }

  ActivateOrDeactivateMachines(form: any, id: number) {
    let headers = this.createAuthorizationHeader();
    return this.http.patch(
      this.apiDomain + `parking-places/machines/${id}/`,
      form,
      {
        headers: headers,
      },
    );
  }

  GetParkingPlaceLiveParking(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head + `&parking_place_id=${id}`;
    return this.http.get(
      this.apiDomain + "parking-places/user-live-parking/" + head,
      {
        headers: headers,
      },
    );
  }

  LiveParkingGraph(form) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?parking_place_id=${form.id}&mins=${form.minutes}`;
    return this.http.get(
      this.apiDomain + "parking-places/live-parking/" + params,
      {
        headers: headers,
      },
    );
  }

  LiveParkingTable(params, form, sorts, id?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    if (id) {
      head = head + `&parking_place_id=${id}`;
    }
    return this.http.get(
      this.apiDomain + "parking-places/user-live-parking/" + head,
      {
        headers: headers,
      },
    );
  }

  GetAverageTimeSpent(date) {
    let headers = this.createAuthorizationHeader();
    // tslint:disable-next-line:max-line-length
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/average-time-spent/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetTopup(date) {
    let headers = this.createAuthorizationHeader();
    let params = `?${this.extractDateChart(date)}`;
    return this.http
      .get(this.apiDomain + "parking-places/parking-topups/" + params, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetTopupSourceChoice() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/topup-source-list/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetPaymentSourceChoice() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "customers/payment-source-list/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteParkingStaff(id) {
    // let headers = this.createAuthorizationHeader();
    return this.http
      .delete(this.apiDomain + "backend/parking-place/staffs/" + id + "/")
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetParkingLogReports(period, period_value) {
    let headers = this.createAuthorizationHeader();
    return (
      this.http
        // .get(this.apiDomain+"backend/parking-logs/?period=months&period_value=1",{ headers: headers })
        .get(
          this.apiDomain +
            "backend/parking-logs/reports/?period=" +
            period +
            "&period_value=" +
            period_value,
          { headers: headers },
        )
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError)
    );
  }

  UpdateUserPassword(form) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(this.apiDomain + "backend/change-user-password/", form, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UploadUserReport(form) {
    console.log("form api");
    console.log(form);
    let headers = this.createAuthorizationHeader();
    let options = { headers };

    return this.http
      .post(
        this.apiDomain + "backend/private-parking/file-upload/",
        form,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  AddBeneficiary(form) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .post(this.apiDomain + "parking-places/beneficiary/", form, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteBeneficiary(id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .delete(this.apiDomain + `parking-places/beneficiary/${id}/`, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  EditBeneficiary(form, id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(
        this.apiDomain + "parking-places/beneficiary/" + id + "/",
        form,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetBeneficiaries() {
    let headers = this.createAuthorizationHeader().set(
      "Content-Type",
      "application/json",
    );
    // headers.set("Authorization", "JWT " + this.jwt).set("Content-Type", "application/json");
    let options = { headers };
    return this.http
      .get(this.apiDomain + "parking-places/beneficiary/", options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetBeneficiariesTest() {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http.get(
      this.apiDomain + "parking-places/beneficiary/",
      options,
    );
  }

  getDownloadStatus(id, class_name = "settlement") {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .get(
        this.apiDomain +
          "backend/offline-report/?object_id=" +
          id +
          "&class_name=" +
          class_name,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  getDownloadCollectionSettlementStatus(id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .get(
        this.apiDomain +
          "backend/offline-report/?object_id=" +
          id +
          "&class_name=collectionsettlement",
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    if (date) {
      head = head.concat(`&${this.extractDate(date)}`);
    }
    return this.http.get(
      this.apiDomain + "parking-places/parking-place-report/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      responseType: "blob" as "blob",
      headers,
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    if (date) {
      head = head.concat(`&${this.extractDate(date)}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "parking-places/parking-place-report/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) =>
          this.downloadExcel(data, `${this.extractDate(date)}Report.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  downloadExcel(data, name) {
    FileSaver.saveAs(data, name);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log("worksheet", worksheet);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION,
    );
  }

  ExportVoucherReportExcel(settlement_id) {
    console.log("download excellll");
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };

    let head = "?id=" + settlement_id + "&report=excel";

    return this.http
      .get(this.apiDomain + "backend/settlement/" + head, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  ExportVoucherCollectionSettlementReportExcel(settlement_id) {
    console.log("download excellll");
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };

    return this.http
      .get(
        this.apiDomain +
          `backend/collection-settlements/report/${settlement_id}?type=excel`,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ExportCollectionSettlementVoucherReport(settlement_id, report_type = "") {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    return this.http
      .get(
        this.apiDomain +
          `backend/collection-settlements/report/${settlement_id}?&type=pdf&report_type=${report_type}`,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/pdf" })))
      .subscribe(
        (data) => this.downloadPDF(data, `SettlementVoucherReport.pdf`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportVoucherReport(settlement_id, type = "") {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };

    let head = "?id=" + settlement_id + "&report=pdf";
    type ? (head = head.concat("&type=" + type)) : "";
    return this.http
      .get(this.apiDomain + "backend/settlement/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/pdf" })))
      .subscribe(
        (data) => this.downloadPDF(data, `SettlementVoucherReport.pdf`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportChannelPartnerSettlementReportExcel(settlement_id) {
    console.log("download excellll");
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };

    let head = "?id=" + settlement_id + "&report=excel";
    return this.http
      .get(
        this.apiDomain + "backend/channel-partner-settlement/" + head,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ExportChannelPartnerSettlementReport(settlement_id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };

    let head = "?id=" + settlement_id + "&report=pdf";
    return this.http
      .get(
        this.apiDomain + "backend/channel-partner-settlement/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/pdf" })))
      .subscribe(
        (data) => this.downloadPDF(data, `SettlementReport.pdf`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  downloadPDF(data, name) {
    FileSaver.saveAs(data, name);
  }

  handleObservableError(error) {
    console.error("An error occurred", error);
    toastr.error("", "Error fetching data.", {
      timeOut: 2000,
    });
    if (error.status == 400) {
      let body = error.json();
      return Promise.reject(body);
    }
    return Promise.reject(error.message || error);
  }

  private extractUserDate(date: Date[]) {
    return `created_at_from=${date[0].getFullYear()}-${
      date[0].getMonth() + 1
    }-${date[0].getDate()}&created_at_to=${date[1].getFullYear()}-${
      date[1].getMonth() + 1
    }-${date[1].getDate()}`;
  }

  private extractDate(date: Date[]) {
    return `from_date=${date[0].getFullYear()}-${
      date[0].getMonth() + 1
    }-${date[0].getDate()}&to_date=${date[1].getFullYear()}-${
      date[1].getMonth() + 1
    }-${date[1].getDate()}`;
  }

  private extractSingleDate(date: Date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

  private extractDateChart(date: Date[]) {
    return `from_date=${date[0].getDate()}-${
      date[0].getMonth() + 1
    }-${date[0].getFullYear()}&to_date=${date[1].getDate()}-${
      date[1].getMonth() + 1
    }-${date[1].getFullYear()}`;
  }

  private extractData(res: any) {
    /* let body = res.json();
    // console.log(body);
    return body || {}; */
    return res;
  }

  private handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    if (error.status == 400) {
      let body = error.json();
      return Promise.reject(body);
    }
    return Promise.reject(error.message || error);
  }

  // ------------maneesha-----------------------------

  GetPrivateParkingLogs(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/private-parking/parking-logs/" + head,
      {
        headers: headers,
      },
    );
  }

  GetPrivateUsers(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/private-parking/users/" + head,
      {
        headers: headers,
      },
    );
  }

  DownloadSampleUsersReport(params, form, sorts) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "backend/private-parking/download-excel/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `USERSampleReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetPrivateParkingDashboardData() {
    let headers = this.createAuthorizationHeader();
    // let params = date ? `?${this.extractDate(date)}` : "";
    return this.http
      .get(this.apiDomain + "backend/private-parking/dashboard/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetChannelDashboard() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/channel/dashboard/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetSubscriptionsList() {
    let headers = this.createAuthorizationHeader();

    return this.http.get(
      `${this.apiDomain}backend/account/account-subscriptions/`,
      {
        headers: headers,
      },
    );
  }
  GetAccountSubscribers(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      `${this.apiDomain}backend/account/user-subscription/` + head,
      {
        headers: headers,
      },
    );
  }
  GetCompany(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/account/" + id, { headers: headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  AddCompany(form: any) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .post(this.apiDomain + "backend/account/", form, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  objectToFormData(obj: any, form?: FormData, namespace?) {
    const fd = form || new FormData();
    let formKey;

    for (const property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (namespace) {
          formKey = namespace + "[" + property + "]";
        } else {
          formKey = property;
        }

        // if the property is an object, but not a File,
        // use recursivity.
        if (
          typeof obj[property] === "object" &&
          !(obj[property] instanceof File)
        ) {
          this.objectToFormData(obj[property], fd, property);
        } else {
          // if it's a string or a File object
          fd.append(formKey, obj[property]);
        }
      }
    }

    return fd;
  }

  editCompany(id: any, form: any) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    const formData = this.objectToFormData(form);
    return this.http
      .put(this.apiDomain + "backend/account/" + id + "/", formData, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetCompanyStaffs(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + `backend/account/account-staff/?account_id=${id}`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetCompanies(form?: any) {
    let headers = this.createAuthorizationHeader();
    let head = "?";
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http
      .get(this.apiDomain + "backend/account/" + head, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetCompanylist() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/account/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetCorporateDashboardCount() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + `backend/account/dashboard/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  GetCompanyType() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + `backend/account-types/corporateaccounttype/`, {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  DeleteCompany(id: any) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .delete(
        this.apiDomain + "backend/account/delete-corporate-account/" + id + "/",
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  editCompanyStaff(form: any, id: any): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "JWT " + this.jwt,
    });

    return this.http.put<any>(
      `${this.apiDomain}backend/account/account-staff/?account_id=${id}/`,
      form,
      { headers },
    );
  }

  GetDoubleAuthLogs(params, form, sorts, status, date?, parkingPlace?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}&status=${status}&parking_place_title=${parkingPlace}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + "&sortby=ticket_in_time_desc"; //+ sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    // for (let key of Object.keys(form)) {
    //   head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    // }
    return this.http.get(
      this.apiDomain + "parking-manager/vigilant-double-auth-log/" + head,
      {
        headers: headers,
      },
    );
  }

  EditDoubleAuthLogs(form) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let options = { headers };
    return this.http
      .put(
        this.apiDomain + `parking-manager/vigilant-double-auth-log/`,
        form,
        options,
      )
      .toPromise();
  }

  DeleteDoubleAuthLogs(id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .delete(
        this.apiDomain + "parking-manager/vigilant-double-auth-log?uid=" + id,
        options,
      )
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ApproveDoubleAuthLogs(form) {
    let headers = new HttpHeaders({ "Content-Type": "application/json" });
    let options = { headers };
    return this.http
      .put(
        this.apiDomain + `parking-manager/vigilant-double-auth-log/`,
        form,
        options,
      )
      .toPromise();
  }

  GetCountriesList() {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "backend/parking-manager/countries/", {
        headers: headers,
      })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  ExportGuestParkingLogsReport(params, form, sorts, date?, isAdmin = false) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&portal_report=true`);
    return this.http
      .get(
        this.apiDomain + "parking-places/unregistered-vehicles/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `GuestTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  generateCouponCode(): Observable<CouponResponse> {
    return this.http.get<CouponResponse>(
      `${this.apiDomain}pass-valet/random-coupon-generator/`,
      { headers: this.createAuthorizationHeader() },
    );
  }

  GetCompanySubscribersLogs(params, form, sorts, date?, isPrebooking = false) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    if (isPrebooking && form.ticket_type.value != null)
      head += `&prebooking_ticket_type=${form.ticket_type.value}`;

    for (let key of Object.keys(form)) {
      if (isPrebooking && key == "ticket_type") head = head;
      else
        head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/company-susbcribers-tickets/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportCompanySubscribersReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "backend/company-susbcribers-tickets/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CompanySubscribersReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ExportSubscribersReport(params, form, sorts, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params + sorts;
    if (date.length > 0) head = head.concat(`&${this.extractDate(date)}`);
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/subscription/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `SubscriberReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetFailedLogs(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/failed-vigilant-logs/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportFailedLogsReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    // sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/failed-vigilant-logs/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `FailedReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  ResyncTickets(id) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
    };

    return this.http.post(
      this.apiDomain + "backend/resync-failed-vigilant-logs/?ids=" + id,
      options,
    );
  }

  GetPassSummaryReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "parking-manager/portal-summary-view/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportPassSummaryReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    // sorts = sorts.prop ? `&sortby=${sorts.prop}_${sorts.dir}` : "";
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "parking-manager/portal-summary-view/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `PassSummary.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetConsumptionReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    console.log("Date in get parking logs", date);
    head = date ? head.concat(`&start_date=` + date) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "backend/consumption-report/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportConsumptionReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&start_date=` + date) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/consumption-report/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `ConsumptionReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetCashoutUsersReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "customers/cashout-user-report/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportCashoutUsersReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "customers/cashout-user-report/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `CashoutUsersReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetDeletedTicketsReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(
      this.apiDomain + "parking-places/deleted-ticket-report/" + head,
      {
        headers: headers,
      },
    );
  }

  ExportDeletedTicketsReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(
        this.apiDomain + "parking-places/deleted-ticket-report/" + head,
        options,
      )
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `DeletedTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  GetResyncedTicketsReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    return this.http.get(this.apiDomain + "backend/resync-log-report/" + head, {
      headers: headers,
    });
  }

  ExportResyncedTicketsReport(params, form, date?) {
    let headers = this.createAuthorizationHeader();
    let options = {
      headers,
      responseType: "blob" as "blob",
    };
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    head = date ? head.concat(`&${this.extractDate(date)}`) : head;

    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    head = head.concat(`&report=true`);
    return this.http
      .get(this.apiDomain + "backend/resync-log-report/" + head, options)
      .pipe(map((res) => new Blob([res], { type: "application/vnd.ms-excel" })))
      .subscribe(
        (data) => this.downloadExcel(data, `ResyncedTicketsReport.xlsx`),
        (err) => {
          console.log("error");
          console.error(err);
        },
      );
  }

  // Shop Service methods
  getParkingPlaceShops(params, form, sorts, parkingPlaceId) {
    return this.http.get(
      `${this.apiDomain}parking-places/shops/?parking_place_id=${parkingPlaceId}`,
      { headers: this.createAuthorizationHeader() },
    );
  }
  createParkingPlaceShop(data) {
    return this.http.post(`${this.apiDomain}parking-places/shops/`, data, {
      headers: this.createAuthorizationHeader(),
    });
  }
  editParkingPlaceShop(data, shopId) {
    return this.http.put(
      `${this.apiDomain}parking-places/shops/?shop_id=${shopId}`,
      data,
      { headers: this.createAuthorizationHeader() },
    );
  }
  deleteParkingPlaceShop(shopId) {
    return this.http.delete(
      `${this.apiDomain}parking-places/shops/?shop_id=${shopId}`,
      { headers: this.createAuthorizationHeader() },
    );
  }
  // Shop Operator methods
  getParkingPlaceShopsOperaotrs(params, form, sorts, shopId) {
    return this.http.get(
      `${this.apiDomain}backend/parking-staffs-shop-operators/?shop_id=${shopId}`,
      { headers: this.createAuthorizationHeader() },
    );
  }
  createParkingPlaceShopsOperaotrs(data) {
    return this.http.post(`${this.apiDomain}backend/create-user/`, data, {
      headers: this.createAuthorizationHeader(),
    });
  }
  GetCountryCodesList(): Observable<CountryCodeDetails[]> {
    return this.http.get<CountryCodeDetails[]>(
      "/assets/config/countryCodes.json",
    );
  }
  EditParkingStaff(form, id) {
    const headers = this.createAuthorizationHeader();
    return this.http
      .put(this.apiDomain + `backend/create-user/${id}/`, form, { headers })
      .toPromise();
  }

  ParkingStaffDelete(id): Observable<any> {
    return this.http.delete(`${this.apiDomain}backend/create-user/${id}/`, {
      headers: this.createAuthorizationHeader(),
    });
  }
  GetDetails(id) {
    return this.http.get(
      this.apiDomain +
        "pass-valet/valet-guests-ticket-detail/?ticket_id_encrypted=" +
        id,
    );
  }

  GetVehicleDetails(id, dropOffLocationId?: string) {
    let url =
      this.apiDomain +
      "pass-valet/valet-guests-request-vehicle/?valet_ticket_id=" +
      id;
    if (dropOffLocationId) {
      url += "&drop_off_location_id=" + dropOffLocationId;
    }
    return this.http.post(url, "");
  }
  PayForVehiclePayment(endpoint, data) {
    return this.http.post(this.apiDomain + endpoint, data);
  }

  GetVehicleDetailsMyCar(id) {
    return this.http.get(
      this.apiDomain + "pass-valet/valet-ticket-detail/?ticket_id=" + id,
    );
  }

  Payment(form) {
    return this.http.post(
      this.apiDomain + "backend/payment_ksa/valet-create_payment/",
      form,
    );
    // return this.http.post(this.apiDomain + "pass-valet/valet-transactions-tap/",form);
  }

  PaymentSuccess(form) {
    return this.http.post(
      this.apiDomain + "customers/valet-guest-transactions/",
      form,
    );
  }

  SaveValletParking(data): Promise<any> {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .post(this.apiDomain + "pass-valet/", data, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetValletParkingById(id) {
    let headers = this.createAuthorizationHeader();
    return this.http
      .get(this.apiDomain + "pass-valet/?id=" + id, { headers: headers })
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  UpdateValetParking(data, id): Promise<any> {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .put(this.apiDomain + "pass-valet/" + id + "/", data, options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  DeleteValetParking(id) {
    let headers = this.createAuthorizationHeader();
    let options = { headers };
    return this.http
      .delete(this.apiDomain + "pass-valet/" + id + "/", options)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
  GetValletParking(params) {
    let headers = this.createAuthorizationHeader();
    let httpParams = new HttpParams();
    httpParams.set("offset", params.offset);
    httpParams.set("limit", params.limit);

    return this.http.get(this.apiDomain + "pass-valet/", {
      headers: headers,
      params: httpParams,
    });
  }
  GetValletParkingStaff(params, form, sorts, id) {
    let headers = this.createAuthorizationHeader();
    params = `offset=${params.offset}&limit=${params.limit}`;
    let head = "?" + params;
    for (let key of Object.keys(form)) {
      head = head.concat(`&${key}=${form[key].value ? form[key].value : ""}`);
    }
    if (id != null) head = head + `&valet_site_id=${id}`;
    return this.http.get(this.apiDomain + "pass-valet/valet-staffs/" + head, {
      headers: headers,
    });
  }
  EditValletParkingStaff(form, id) {
    const headers = this.createAuthorizationHeader();
    return this.http
      .put(this.apiDomain + `pass-valet/create-valet-staff/${id}/`, form, {
        headers,
      })
      .toPromise();
  }

  // Apply coupon for valet service
  ApplyValetCoupon(data) {
    let headers = this.createAuthorizationHeader();
    return this.http.post(
      this.apiDomain + "pass-valet/apply-coupon-valet-guest/",
      data,
      {
        headers: headers,
      },
    );
  }

  // Charge with zero amount for valet service
  ChargeWithZeroAmount(data) {
    return this.http.post(
      this.apiDomain + "pass-valet/charge-with-zero-amount/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      },
    );
  }
}
